<!-- =========================================================================================
    File Name: Invoice.vue
    Description: Invoice Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div id="invoice-page" v-if="isMounted">
    <vx-card id="invoice-container">
      <!-- INVOICE METADATA -->

      <div class="vx-row leading-loose p-base" vs-align="flex-start">
        <vs-row>
          <vs-col vs-w="6">
            <img class="p-0" height="100px" :src="getLogo" alt="vuexy-logo" />
            <vs-row>
              <vs-col>{{ userDetails.billingAddress.billAddress1 }}</vs-col>
            </vs-row>
            <vs-row>
              <vs-col>{{ userDetails.billingAddress.billAddress2}}</vs-col>
            </vs-row>
            <vs-row>
              <vs-col>Tel: {{userDetails.billingAddress.contactNumber}} Fax: {{ userDetails.billingAddress.faxNumber}}</vs-col>
            </vs-row>
          </vs-col>
          <vs-col vs-w="6" class="text-right">
            <h1>Purchase Order</h1>
            <div class="invoice__invoice-detail mt-6">
              <p class="font-bold text-lg">{{showLabel}} NO.: {{ userDetails.mainInfo.poNumber }}</p>

              <p class="font-bold text-lg">{{showLabel}} DATE: {{ userDetails.mainInfo.poDate }}</p>

              <p class="font-bold text-lg">JOB NO.: {{ userDetails.mainInfo.poJobNo }}</p>

              <p class="font-bold text-lg">PR NO.{{ userDetails.mainInfo.poPrNumber }}</p>
            </div>
          </vs-col>
        </vs-row>

        <vs-row>
          <vs-col vs-w="5">
            <div class="vx-col mt-base text-xl font-bold bg-grey p-02">Vendor</div>
            <vs-row>{{ userDetails.vendor.companyName }}</vs-row>
            <vs-row>{{ userDetails.vendor.address1 }}</vs-row>
            <vs-row>{{ userDetails.vendor.address2 }}</vs-row>
            <vs-row>{{ userDetails.vendor.contactNo }}</vs-row>
          </vs-col>

          <vs-col vs-offset="2" vs-w="5">
            <div class="vx-col mt-base text-xl font-bold bg-grey p-2">Bill & Ship To</div>
            <vs-row>{{ userDetails.branch.branchName }}</vs-row>
            <vs-row>{{ userDetails.billingAddress.billAddress1 }}</vs-row>
            <vs-row>{{ userDetails.billingAddress.billAddress2 }}</vs-row>
            <vs-row>{{ userDetails.billingAddress.contactNumber }}</vs-row>
          </vs-col>
        </vs-row>

        <vs-row>
          <vs-col vs-w="12">
            <p class>Dear Sir/Madam,</p>
            <p class>We hereby confirmed the following:</p>
            <!-- INVOICE TASKS TABLE -->
            <vs-table hoverFlat :data="userDetails.items">
              <!-- HEADER -->
              <template slot="thead">
                <vs-th class="pointer-events-none">Item Code</vs-th>
                <vs-th class="pointer-events-none">Item Description</vs-th>
                <vs-th class="pointer-events-none">Qty.</vs-th>
                <vs-th class="pointer-events-none">Price</vs-th>
                <vs-th class="pointer-events-none">Total Amount</vs-th>
              </template>

              <!-- DATA -->
              <template slot-scope="{data}">
                <vs-tr v-for="(tr, index) in data" :key="index">
                  <vs-td :data="data[index].itemName">{{ data[index].itemName }}</vs-td>
                  <vs-td :data="data[index].description">{{ data[index].description }}</vs-td>
                  <vs-td :data="data[index].qty">{{ data[index].qty }}</vs-td>
                  <vs-td
                    :data="data[index].price"
                  >{{ data[index].price }} {{ userDetails.currency.currencyName}}</vs-td>
                  <vs-td
                    :data="data[index].total"
                  >{{ data[index].total }} {{ userDetails.currency.currencyName}}</vs-td>
                </vs-tr>
              </template>
            </vs-table>

            <!-- INVOICE SUMMARY TABLE -->
            <vs-table hoverFlat class="w-1/2 ml-auto mt-4" :data="userDetails.items">
              <vs-tr>
                <vs-th class="pointer-events-none">SUBTOTAL</vs-th>
                <vs-td>{{ userDetails.mainInfo.subTotal }} {{ userDetails.currency.currencyName}}</vs-td>
              </vs-tr>
              <vs-tr>
                <vs-th class="pointer-events-none">TAX ({{ userDetails.mainInfo.tax }}%)</vs-th>
                <vs-td>{{ getTax() }} {{ userDetails.currency.currencyName}}</vs-td>
              </vs-tr>
              <vs-tr>
                <vs-th class="pointer-events-none">TOTAL</vs-th>
                <vs-td>{{ userDetails.mainInfo.total }} {{ userDetails.currency.currencyName}}</vs-td>
              </vs-tr>
            </vs-table>
          </vs-col>
        </vs-row>
      </div>

      <div class="p-1">
        <vs-table hoverFlat class="w-full" :data="userDetails.items">
          <vs-tr class>
            <vs-th>
              <div class="w-full bg-grey p-3">
                <div class="text-center">PREPARED</div>
              </div>
            </vs-th>
            <vs-th class="pointer-events-none">
              <div class="w-full bg-grey p-3">
                <div class="text-center">VERIFIED</div>
              </div>
            </vs-th>
            <vs-th class="pointer-events-none">
              <div class="w-full bg-grey p-3">
                <div class="text-center">APPROVED</div>
              </div>
            </vs-th>
          </vs-tr>
          <vs-tr>
            <vs-td class="pointer-events-none">
              <div class="w-full">
                <div class="text-center">
                  <p>Procurement Department</p>
                  <div
                    class="font-light italic"
                  >{{ parseFromISOToLong(userDetails.mainInfo.created_at) }}</div>
                </div>
              </div>
            </vs-td>
            <vs-td>
              <div class="w-full">
                <div class="text-center">
                  <p>Balachandar Ramani</p>
                  <div
                    class="font-light italic"
                  >{{ parseFromISOToLong(userDetails.mainInfo.approvedFinance) }}</div>
                </div>
              </div>
            </vs-td>
            <vs-td>
              <div class="w-full">
                <div class="text-center">
                  <p>Taufik Othman</p>
                  <div
                    class="font-light italic"
                  >{{ parseFromISOToLong(userDetails.mainInfo.approvedMd) }}</div>
                </div>
              </div>
            </vs-td>
          </vs-tr>
        </vs-table>
      </div>

      <!-- INVOICE FOOTER -->
    </vx-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "@/axios.js";

import { axiosMixin } from "../../../mixin/axiosMixin";
import { helperMixin } from "../../../mixin/helperMixin";
import { alertMixin } from "../../../mixin/alertMixin";

export default {
  props: {
    title: String
  },
  mixins: [axiosMixin, helperMixin, alertMixin],
  data() {
    return {
      isMounted: false,
      mailTo: "",
      userDetails: {},
      poCurrency: "",
      userId: "",
      poVendorId: "",
      id: "",
      logo: ""
    };
  },
  computed: {
    ...mapGetters({
      getUserInfo: "auth/getUserInfo",
      getDataStructureInChunk: "profile/getDataStructureInChunk"
    }),
    showLabel() {
      return "PO";
    },
    getLogo() {
      return axios.defaults.baseURL + "/storage/" + this.logo;
    }
  },
  methods: {
    printInvoice() {
      window.print();
    },
    getTax() {
      return (
        (parseInt(this.userDetails.mainInfo.tax) / 100) *
        parseInt(this.userDetails.mainInfo.subTotal)
      );
    },
    getUserPRUserInfo() {
      this.aronPost(
        "poDetails",
        {
          poCurrency: this.poCurrency,
          userId: this.userId,
          vendorId: this.poVendorId,
          poId: this.id
        },
        "",
        ""
      )
        .then(response => {
          this.userDetails = response.data;
          this.isMounted = true;
          var mythis = this;
          setTimeout(function() {
             mythis.printInvoice();
          }, 1000);
        })
        .catch(error => {
          this.decodeErrorFromAxios(error);
        });
    }
  },
  components: {},
  mounted() {
    this.poCurrency = this.$route.query.poCurrency;
    this.userId = this.$route.query.userId;
    this.poVendorId = this.$route.query.poVendorId;
    this.id = this.$route.query.id;
    this.logo = this.$route.query.logo;

    this.getUserPRUserInfo();
    this.$emit("setAppClasses", "invoice-page");
  },
  created() {
    this.isMounted = false;
  }
};
</script>

<style lang="scss">
@media print {
  .invoice-page {
    * {
      visibility: hidden;
    }

    #content-area {
      margin: 0 !important;
    }

    .vs-con-table {
      .vs-con-tbody {
        overflow: hidden !important;
      }
    }

    #invoice-container,
    #invoice-container * {
      visibility: visible;
    }
    #invoice-container {
      position: absolute;
      left: 0;
      top: 0;
      box-shadow: none;
    }
  }
}

@page {
  size: auto;
}
</style>
